import React, { DetailedHTMLProps, InputHTMLAttributes, TextareaHTMLAttributes } from "react";

export const Card = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`rounded-3xl border border-white/10 bg-white/5 p-6 ${className}`}>{children}</div>
);

export const Badge = ({ children }: { children: React.ReactNode }) => (
  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-indigo-500/15 border border-indigo-400/20 text-indigo-200">{children}</span>
);

export const Pill = ({ children }: { children: React.ReactNode }) => (
  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-white/5 border border-white/10 text-slate-300">{children}</span>
);

export const Input = ({ label, ...props }: { label: string; } & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => (
  <label className="block">
    <span className="block text-sm text-slate-300 mb-1">{label}</span>
    <input {...props} className="w-full px-4 py-3 rounded-xl bg-[#151a28] border border-white/10 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 placeholder:text-slate-500" />
  </label>
);

export const Textarea = ({ label, ...props }: { label: string; } & DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>) => (
  <label className="block">
    <span className="block text-sm text-slate-300 mb-1">{label}</span>
    <textarea {...props} className="w-full px-4 py-3 rounded-xl bg-[#151a28] border border-white/10 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 placeholder:text-slate-500" />
  </label>
);

export const ContactCard = ({
  icon,
  title,
  value,
  onClick,
}: {
  icon: React.ReactNode;
  title: string;
  value: string;
  onClick: () => void;
}) => (
  <Card>
    <div className="flex items-center gap-3 text-slate-300" onClick={onClick}>
      <div className="p-2 rounded-xl bg-indigo-500/15 border border-indigo-400/20">{icon}</div>
      <div>
        <div className="text-slate-400 text-sm">{title}</div>
        <div className="font-medium">{value}</div>
      </div>
    </div>
  </Card>
);

export const ValueCard = ({
  title,
  text,
  icon,
}: {
  title: string;
  text: string;
  icon: React.ReactNode;
}) => (
  <Card className="flex items-start gap-4">
    <div className="p-2 rounded-xl bg-indigo-500/15 border border-indigo-400/20">{icon}</div>
    <div>
      <h3 className="text-lg font-semibold text-slate-100">{title}</h3>
      <p className="text-slate-300 mt-1">{text}</p>
    </div>
  </Card>
);
